exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".intro .img-wrapper{margin:0 auto 2em;width:30%}.intro img{margin:0 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./~/postcss-loader!./app/src/Home/components/stylesheets/Welcome.scss
// module id = 452
// module chunks = 0